import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";
import { adminArchivedToggleCommon } from "./exam-admin-common";
import { examAdminExamsDetail } from "./exam-admin-exams-detail";

export const examAdminExams = {
  ...adminArchivedToggleCommon,
  pageTitle: "試験センター",
  pageSubtitle: "正式試験の作成、割り当て、公開、状態遷移、成績公開を管理します。",
  createSuccess: "試験を作成しました",
  archiveSuccess: "試験をアーカイブしました",
  createAndStartSuccess: "試験を作成し、直ちに開始しました",
  createStartNowFailed: "試験は作成されましたが、即時開始に失敗しました：{reason}",
  examRules: "試験ルール：",
  assignedCandidates: "割り当て済み受験者：",
  stats: {
    totalExamsLabel: "試験総数",
    totalExams: "試験総数：{count}",
    summaryUnavailable: "試験ステータス集計の読み込みに失敗しました。凡例の件数は利用できません",
    archivedExamsLabel: "アーカイブ数",
    archivedExams: "アーカイブ数：{count}",
    totalCandidatesLabel: "総受験回数",
    totalCandidates: "総受験回数：{count}",
    totalDurationMinutesLabel: "総試験時間",
    totalDurationMinutes: "総試験時間：{count} 分",
  },
  table: {
    code: "試験コード",
    name: "試験名",
    searchPlaceholder: "試験コードまたは名称で検索",
    codeSearchPlaceholder: "コードで検索",
    paperVersionSearchPlaceholder: "試験用紙名/コードで検索",
    status: commonShortNouns.status,
    paperVersion: "試験用紙バージョン",
    paperVersionMissing: "試験用紙バージョンがありません（ID #{id}）",
    duration: "時間",
    candidates: "受験者数",
    environmentLimits: "コンテナ制限",
    environmentLimitActive: "同時 {count}",
    environmentLimitTotal: "合計 {count}",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  batch: {
    publish: "一括公開",
    start: "一括開始",
    end: "一括終了",
    archive: "一括アーカイブ",
    publishScores: "成績を一括公開",
    selectFirst: "先に試験を選択してください",
    actionSuccess: "{action} の一括実行が完了しました。対象 {count} 件",
    actionPartial: "{action} の一括実行が完了しました。成功 {success} 件、失敗 {failed} 件",
    publishScoresSuccess: "成績の一括公開が完了しました。対象 {count} 件",
    publishScoresPartial: "成績の一括公開が完了しました。成功 {success} 件、失敗 {failed} 件",
    confirm: {
      batchpublishScoresTitle: "成績を一括公開しますか？",
      batchpublishScoresDescription: "選択した試験の成績を一括公開します。操作を確認してください。",
      batcharchiveTitle: "一括アーカイブしますか？",
      batcharchiveDescription: "選択した試験を一括アーカイブします。操作を確認してください。",
      batchendTitle: "一括終了しますか？",
      batchendDescription: "選択した試験を一括終了します。操作を確認してください。",
      batchstartTitle: "一括開始しますか？",
      batchstartDescription: "選択した試験を一括開始します。操作を確認してください。",
      batchpublishTitle: "一括公開しますか？",
      batchpublishDescription: "選択した試験を一括公開します。操作を確認してください。",
    },
  },
  newExamDrawerTitle: "試験を新規作成",
  codeRulePrefix: "試験コードは初回保存成功後に自動生成されます。形式：",
  codeRulePattern: "E-年週-連番",
  codeRuleSuffix: "。生成後は変更できません。",
  createWizard: {
    previous: "前へ",
    next: "次へ",
    submit: "試験を作成",
    durationRequired: "試験時間を入力してください",
    startNowDurationRequired: "作成後すぐ開始する場合は試験時間の設定が必要です",
    startMode: "開始方式",
    startModeScheduled: "予約開始",
    startModeImmediate: "作成後すぐ開始",
    startModeImmediateHint:
      "作成後、システムが自動で「すぐ開始」を実行します。手動で再度クリックする必要はありません。",
    endTimeAutoHint: "終了時刻は自動計算されます：{value}",
    endTimeAutoHintEmpty:
      "先に開始時刻と試験時間を入力してください。システムが終了時刻を自動計算します。",
    openExamHint:
      "現在は公開試験です。すべての受験者が参加できるため、この手順で受験者を指定する必要はありません。",
    recommendDuration: "試験用紙の推奨時間を使用",
    recommendDurationUnavailable: "現在の試験用紙には推奨時間が設定されていません",
    recommendDurationApplied: "推奨時間を適用しました：{minutes} 分",
    openPaperPicker: "試験用紙を選択",
    paperPickerTitle: "試験用紙バージョンを選択",
    paperPickerSearchPlaceholder: "試験用紙コードまたは名称で検索",
    openCandidatePicker: "受験者を検索して選択",
    candidatePickerTitle: "受験者を選択",
    candidatePickerSearchPlaceholder: "氏名またはユーザー名で検索",
    recommendName: "AI 推奨名称",
    recommendedNameTemplate: "{title} · 正式試験 · {date}",
    recommendedNameApplied: "推奨試験名を適用しました",
    typePolicies: "設問タイプポリシー",
    paperOptionLabel: "{code} · {title} · V{versionNo}（{versionCode}）",
    typePolicyShuffleQuestions: "同一タイプ内で問題順をシャッフル",
    typePolicyShuffleOptions: "選択肢をシャッフル",
    typePolicyAllowSelfCheck: "受験者の自主実行を許可",
    typePolicyMaxSelfCheckCount: "最大実行回数",
    typePolicyMaxSelfCheckCountPlaceholder: "未入力で無制限",
    typePolicyAllowSelfCheckWithCount: "受験者の自主検証を許可（{count} 回）",
    typePolicyGroupOrder: "順序戦略",
    typePolicyGroupPractical: "実技戦略",
    typePolicyGroupAttackDefense: "攻防戦略",
    typePolicyMaxCreateCount: "環境作成回数上限",
    typePolicyMaxCreateCountPlaceholder: "未入力で無制限",
    typePolicyMaxCreateCountWithCount: "環境作成上限（{count} 回）",
    typePolicyFlagResultMode: "Flag 採点タイミング",
    typePolicyFlagResultModeImmediate: "即時採点して結果表示",
    typePolicyFlagResultModeDeferred: "提出後に一括採点",
    typePolicySummary: "有効化: {summary}",
    typePolicySummaryNone: "なし",
    customFieldsSectionTitle: "カスタム項目",
    selectPaperAction: "選択",
    steps: {
      basic: "試験用紙と基本情報",
      rules: "試験ルール",
      candidates: "受験者範囲",
    },
  },
  status: "試験状態",
  name: "試験名",
  nameRequired: "試験名を入力してください",
  namePlaceholder: "試験名を入力",
  entryCode: "入口コード",
  entryCodeRequired: "入口コードを入力してください",
  entryCodePlaceholder: "例：E-2613-003 または exam-security-001",
  entrySubdomain: "入口サブドメイン接頭辞",
  entrySubdomainPlaceholder: "例：e-2613-003（e-2613-003.<root-domain> でアクセス）",
  paperVersion: "試験用紙バージョン",
  paperVersionRequired: "試験用紙バージョンを選択してください",
  paperVersionPlaceholder: "試験用紙バージョンを選択",
  startTime: "開始時刻",
  endTime: "終了時刻",
  durationMinutes: "試験時間（分）",
  publishScoreMode: "成績公開方式",
  allowLateEntry: "遅刻入室を許可",
  lateEntryGraceMinutes: "最大遅刻許容時間（分）",
  lateEntryGraceMinutesPlaceholder: "未入力で無制限",
  earliestSubmitAt: "最早提出時刻",
  earliestSubmitAtPlaceholder: "この時刻までは提出できません",
  allowReentry: "中断後の再入室を許可",
  allowMultipleSubmit: "複数回提出を許可",
  maxAttemptCount: "最大作答回数",
  maxAttemptCountRequired: "最大作答回数を入力してください",
  maxAttemptCountPlaceholder: "未入力で無制限",
  accessMode: "参加範囲",
  accessModeAssigned: "指定受験者のみ",
  accessModeOpen: "公開試験（任意の受験者）",
  resultVisibility: "成績表示範囲",
  answerVisibility: "解答表示範囲",
  assignCandidates: "受験者を割り当て",
  assignCandidatesPlaceholder: "この試験の受験者を選択",
  advancedConfig: "拡張設定",
  advancedConfigHelp: "一般的な拡張設定はフォームで管理し、システムが自動生成します",
  advancedConfigRetainUnknown: "未認識のキーは編集時に保持されます。",
  examNotice: "試験説明",
  examNoticePlaceholder: "受験前の注意事項、環境説明、解答時の注意など",
  submitNotice: "提出時メッセージ",
  submitNoticePlaceholder: "提出確認時に受験者へ表示するメッセージ",
  scoreNotice: "成績公開説明",
  scoreNoticePlaceholder: "例：成績は手動確認後に一括公開されます",
  proctoringNote: "監考メモ",
  proctoringNotePlaceholder: "例：この試験では全時間帯でカメラ起動が必要です（V2 予約）",
  environmentNote: "環境メモ",
  environmentNotePlaceholder: "例：プログラミング問題と実技問題の実行環境に関する説明",
  candidateEnvironmentMaxActive: "受験者ごとの同時コンテナ上限",
  candidateEnvironmentMaxActivePlaceholder: "未入力で無制限",
  candidateEnvironmentMaxTotal: "受験者ごとのコンテナ作成回数上限",
  candidateEnvironmentMaxTotalPlaceholder: "未入力で無制限",
  enableAiReview: "AI 初期レビューを有効化",
  autoRecycleEnvironment: "環境を自動回収",
  showQuestionNavigation: "問題番号ナビゲーションを表示",
  configJsonPreview: "config_json プレビュー",
  detail: examAdminExamsDetail,
};
